import {
    FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_CHECK,
  FORGOT_PASSWORD_CHECK_SUCCESS,
  FORGOT_PASSWORD_SET_TOKEN,
  FORGOT_PASSWORD_RESET,
  FORGOT_PASSWORD_RESET_SUCCESS,
  REQUEST_RESET_CLOSE_POPUP,
  REQUEST_RESET_OPEN_SUCCESS,
  REQUEST_RESET_OPEN_FAIL,
  RESET_CLOSE_POPUP,
  RESET_OPEN_SUCCESS,
  RESET_OPEN_FAIL
} from "./types";

export const forgotPassword = payload => {
  return {
      type: FORGOT_PASSWORD,
      payload: payload
  };
};

export const forgotPasswordSuccess = payload => {
  return {
      type: FORGOT_PASSWORD_SUCCESS,
      payload: payload
  };
};

export const forgotPasswordCheck = payload => {
  return {
      type: FORGOT_PASSWORD_CHECK,
      payload: payload
  };
};

export const forgotPasswordCheckSuccess = payload => {
  return {
      type: FORGOT_PASSWORD_CHECK_SUCCESS,
      payload: payload
  };
};

export const forgotPasswordSetToken = payload => {
  //console.log(payload)
  return {
      type: FORGOT_PASSWORD_SET_TOKEN,
      payload: payload
  };
};

export const forgotPasswordReset = payload => {
  return {
      type: FORGOT_PASSWORD_RESET,
      payload: payload
  };
};

export const forgotPasswordResetSuccess = payload => {
  return {
      type: FORGOT_PASSWORD_RESET_SUCCESS,
      payload: payload
  };
};

export const requestResetClosePopup = () => {
  return {
      type: REQUEST_RESET_CLOSE_POPUP,
  };
};

export const requestResetOpenSuccess = () => {
  return {
      type: REQUEST_RESET_OPEN_SUCCESS,
  }
}

export const requestResetOpenFail = (payload) => {
  return {
      type: REQUEST_RESET_OPEN_FAIL,
      payload:payload
  }
}

export const resetClosePopup = () => {
  return {
      type: RESET_CLOSE_POPUP,
  };
};

export const resetOpenSuccess = () => {
  return {
      type: RESET_OPEN_SUCCESS,
  }
}

export const resetOpenFail = (payload) => {
  return {
      type: RESET_OPEN_FAIL,
      payload:payload
  }
}
